import { createSlice } from '@reduxjs/toolkit';
import { tanstackQueryClient } from '@provider/tanstack';
import { getComponentEntryQueryKey, makeComponentEntryEnvelopeFromComponentEnvelope, iArkEntryDataSchema, getEntriesForComponentQueryKey } from '@utils/component-framework';
import { createScopedStore, createIndependentStore } from '@utils/react';

let resetCounter = 0;
function makeIArkStore(initialState) {
  const slice = createSlice({
    name: `i-ark`,
    initialState,
    reducers: {
      setZoomLevel(state, action) {
        state.zoom = action.payload;
      },
      togglePrintLayout(state, action) {
        state.showPrintLayout = action.payload;
      },
      toggleLineTool(state, action) {
        state.lineToolEnabled = action.payload.enabled ?? !state.lineToolEnabled;
        state.selectedItemId = undefined;
      },
      lineInserted(state) {
        state.lineToolEnabled = false;
      },
      changeLineColor(state, action) {
        state.lineColor = action.payload;
      },
      selectItem(state, action) {
        state.selectedItemId = action.payload;
      },
      deselectItem(state) {
        state.selectedItemId = undefined;
      },
      resetEntry(state) {
        const previousEntry = tanstackQueryClient.getQueryData(getComponentEntryQueryKey(state.entryKey));
        const nextEntryKey = `new-entry.${state.component.envelope.ID}.${resetCounter++}`;
        tanstackQueryClient.setQueryData(getComponentEntryQueryKey(nextEntryKey), () => {
          const nextEntry = {
            ...previousEntry,
            data: iArkEntryDataSchema.parse({}),
            entryKey: nextEntryKey,
            state: {
              result: "success",
              isMutating: false
            },
            envelope: {
              ...makeComponentEntryEnvelopeFromComponentEnvelope({
                id: previousEntry?.envelope.userID ?? ""
              }, state.component.envelope)
            }
          };

          //
          // STEP: Ensure that our collection of all entries are updated to
          // reflect that a new entry is about to be added
          //
          tanstackQueryClient.setQueryData(getEntriesForComponentQueryKey(state.component.envelope.ID), prev => {
            const next = prev ?? [];
            const prevInArr = next?.find(it => it.envelope.objectID === previousEntry?.envelope.objectID);
            if (previousEntry) {
              if (prevInArr) {
                prevInArr.data = JSON.parse(JSON.stringify(previousEntry.data));
                prevInArr.envelope = JSON.parse(JSON.stringify(previousEntry.envelope));
              } else {
                next.push({
                  data: JSON.parse(JSON.stringify(previousEntry.data)),
                  envelope: JSON.parse(JSON.stringify(previousEntry.envelope))
                });
              }
            }
            next.push(nextEntry);
            return next;
          });
          return nextEntry;
        });
        state.entryKey = nextEntryKey;
      }
    }
  });
  const store = createIndependentStore({
    ...slice,
    devTool: {
      name: `i-ark.${initialState.entryKey}`
    }
  });
  return store;
}
const iArkStore = createScopedStore(makeIArkStore({
  entryKey: "",
  showPrintLayout: false,
  component: {
    data: undefined,
    envelope: undefined
  },
  lineColor: "#000",
  lineToolEnabled: false,
  zoom: 1
}));

export { iArkStore, makeIArkStore };
//# sourceMappingURL=store.js.map
